export type Context = {
  alreadySeenOfferIds: string[];
};
